export const getSentenceCase = (text?: string | null): string => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
};
